import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutTeamCircles = {
  factory: EElement({
    id: '03914adc-6609-e8ef-b1dc-bc37101aa61e',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('4fd27d86-c187-a29e-5153-a2e1e5c75e73')]),
      children: EList([
        EElement({
          id: 'a618c839-5743-a4f9-946e-8350ed771ccd',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'f1deee38-544a-4e16-8bae-30b17cf272ad',
                type: qualify(Plugins.name('Basic'), Component.name('Heading')),
                data: ERecord({
                  tag: EEnum('h2'),
                  styleBlockIds: EList([
                    EText('9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'f1deee38-544a-4e16-8bae-30b17cf272ae',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Team section'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '041f8f2c-c661-ef73-5113-b6c284a1271c',
                type: qualify(
                  Plugins.name('Basic'),
                  Component.name('Paragraph')
                ),
                data: ERecord({
                  styleBlockIds: EList([
                    EText('e8e462ae-eca2-3d8e-55fa-0d15b916d1ba'),
                  ]),
                  children: EList([
                    EElement({
                      id: '041f8f2c-c661-ef73-5113-b6c284a1271d',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText(
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem.'
                      ),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'f757feea-3eef-f81c-099a-f3fb6681ff40',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('e75db611-ebb8-70fd-6c02-1b92c4dafa11'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'fd40045a-b75b-24d8-e6df-7b312dfefd12',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('84cd23a0-7acc-6b97-9559-9b46f4b3ea3c'),
                        ]),
                        children: EList([
                          EElement({
                            id: '31f0b00f-5df3-6c22-9a34-22571f380d45',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627318c99765baa36e6550bf"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('d10cd42c-0487-bbf0-40b1-54a177d72bd9'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'd0c4236e-1dd8-4a5e-69b3-9b643b7a0b62',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('10ea09a1-d6a2-9172-b3a2-cbf78ee99e02'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd0c4236e-1dd8-4a5e-69b3-9b643b7a0b63',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Full Name'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '06c7e9f7-c219-f100-6359-bce9214cc877',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('bff7edfd-b157-9060-4e4f-714ef3b50474'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '06c7e9f7-c219-f100-6359-bce9214cc878',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Role at C'),
                                }),
                                EElement({
                                  id: '43675808-ae6c-7c2d-a9a0-9ab62d945c1d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                                EElement({
                                  id: '404a487e-b2c6-a6ff-b2a0-3a6a9498a0fc',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('\u200D'),
                                }),
                                EElement({
                                  id: '0147c220-1e4c-c99a-62a1-7596506f1990',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Previously: Company 1, Company 2'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'e454eeef-f956-4328-17d8-ce122037e774',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              children: EList([
                                EElement({
                                  id: 'e454eeef-f956-4328-17d8-ce122037e775',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '21b319c1-6bf5-da86-8b91-c3b83f49f2dc',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            xl: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('84cd23a0-7acc-6b97-9559-9b46f4b3ea3c'),
                        ]),
                        children: EList([
                          EElement({
                            id: '21b319c1-6bf5-da86-8b91-c3b83f49f2dd',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627318c99765baa36e6550bf"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('d10cd42c-0487-bbf0-40b1-54a177d72bd9'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '21b319c1-6bf5-da86-8b91-c3b83f49f2de',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('10ea09a1-d6a2-9172-b3a2-cbf78ee99e02'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '21b319c1-6bf5-da86-8b91-c3b83f49f2df',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Full Name'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '21b319c1-6bf5-da86-8b91-c3b83f49f2e0',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('bff7edfd-b157-9060-4e4f-714ef3b50474'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '21b319c1-6bf5-da86-8b91-c3b83f49f2e1',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Role at Company'),
                                }),
                                EElement({
                                  id: '031fdd1d-ad70-3771-d171-fc4472f7ee55',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                                EElement({
                                  id: 'b51789f3-d06b-5be3-3a17-d1f4c656f336',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Previously: Company 1, Company 2'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '21b319c1-6bf5-da86-8b91-c3b83f49f2e4',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              children: EList([
                                EElement({
                                  id: '21b319c1-6bf5-da86-8b91-c3b83f49f2e5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '96317443-7422-ccc6-1b0f-19d6b47c000c',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            xl: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('84cd23a0-7acc-6b97-9559-9b46f4b3ea3c'),
                        ]),
                        children: EList([
                          EElement({
                            id: '96317443-7422-ccc6-1b0f-19d6b47c000d',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627318c99765baa36e6550bf"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('d10cd42c-0487-bbf0-40b1-54a177d72bd9'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '96317443-7422-ccc6-1b0f-19d6b47c000e',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('10ea09a1-d6a2-9172-b3a2-cbf78ee99e02'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '96317443-7422-ccc6-1b0f-19d6b47c000f',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Full Name'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '96317443-7422-ccc6-1b0f-19d6b47c0010',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('bff7edfd-b157-9060-4e4f-714ef3b50474'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '96317443-7422-ccc6-1b0f-19d6b47c0011',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Role at Company'),
                                }),
                                EElement({
                                  id: 'd59e1905-4248-fbef-aff6-925b68e19697',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                                EElement({
                                  id: 'd3c0953a-5d6a-4a40-f506-661e061e0e04',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Previously: Company 1, Company 2'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '96317443-7422-ccc6-1b0f-19d6b47c0014',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              children: EList([
                                EElement({
                                  id: '96317443-7422-ccc6-1b0f-19d6b47c0015',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '136cdde3-24a9-ad8e-f2b8-fd2c0a14780e',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('84cd23a0-7acc-6b97-9559-9b46f4b3ea3c'),
                        ]),
                        children: EList([
                          EElement({
                            id: '136cdde3-24a9-ad8e-f2b8-fd2c0a14780f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627318c99765baa36e6550bf"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('d10cd42c-0487-bbf0-40b1-54a177d72bd9'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '136cdde3-24a9-ad8e-f2b8-fd2c0a147810',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('10ea09a1-d6a2-9172-b3a2-cbf78ee99e02'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '136cdde3-24a9-ad8e-f2b8-fd2c0a147811',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Full Name'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '136cdde3-24a9-ad8e-f2b8-fd2c0a147812',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('bff7edfd-b157-9060-4e4f-714ef3b50474'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '136cdde3-24a9-ad8e-f2b8-fd2c0a147813',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Role at Company'),
                                }),
                                EElement({
                                  id: '7050ba03-8974-e7a2-5f68-c58be2809a8a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                                EElement({
                                  id: '9d572fb3-910f-ce81-ce1b-015fa141d606',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Previously: Company 1, Company 2'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '136cdde3-24a9-ad8e-f2b8-fd2c0a147816',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              children: EList([
                                EElement({
                                  id: '136cdde3-24a9-ad8e-f2b8-fd2c0a147817',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '8bbe1761-deb2-2ab2-e3a1-90adb98dd267',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('84cd23a0-7acc-6b97-9559-9b46f4b3ea3c'),
                        ]),
                        children: EList([
                          EElement({
                            id: '8bbe1761-deb2-2ab2-e3a1-90adb98dd268',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627318c99765baa36e6550bf"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('d10cd42c-0487-bbf0-40b1-54a177d72bd9'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '8bbe1761-deb2-2ab2-e3a1-90adb98dd269',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('10ea09a1-d6a2-9172-b3a2-cbf78ee99e02'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8bbe1761-deb2-2ab2-e3a1-90adb98dd26a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Full Name'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '8bbe1761-deb2-2ab2-e3a1-90adb98dd26b',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('bff7edfd-b157-9060-4e4f-714ef3b50474'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8bbe1761-deb2-2ab2-e3a1-90adb98dd26c',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Role at Company'),
                                }),
                                EElement({
                                  id: 'b7406138-698b-25ff-28a6-c365c6771089',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                                EElement({
                                  id: 'f51c0a87-7620-5e6c-c5c3-d37018edc919',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Previously: Company 1, Company 2'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '8bbe1761-deb2-2ab2-e3a1-90adb98dd26f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              children: EList([
                                EElement({
                                  id: '8bbe1761-deb2-2ab2-e3a1-90adb98dd270',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '2426d5a9-2ab5-b56d-7a50-ee081593b94d',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('84cd23a0-7acc-6b97-9559-9b46f4b3ea3c'),
                        ]),
                        children: EList([
                          EElement({
                            id: '2426d5a9-2ab5-b56d-7a50-ee081593b94e',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627318c99765baa36e6550bf"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('d10cd42c-0487-bbf0-40b1-54a177d72bd9'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '2426d5a9-2ab5-b56d-7a50-ee081593b94f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('10ea09a1-d6a2-9172-b3a2-cbf78ee99e02'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '2426d5a9-2ab5-b56d-7a50-ee081593b950',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Full Name'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '2426d5a9-2ab5-b56d-7a50-ee081593b951',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('bff7edfd-b157-9060-4e4f-714ef3b50474'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '2426d5a9-2ab5-b56d-7a50-ee081593b952',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Role at Company'),
                                }),
                                EElement({
                                  id: '799542a1-06d8-c445-6e0a-dfd687813ebf',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('LineBreak')
                                  ),
                                  data: ERecord({}),
                                }),
                                EElement({
                                  id: 'b73f0d8f-d84b-e27b-13e7-3ae68007eb7c',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Previously: Company 1, Company 2'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '2426d5a9-2ab5-b56d-7a50-ee081593b955',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              children: EList([
                                EElement({
                                  id: '2426d5a9-2ab5-b56d-7a50-ee081593b956',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '4fd27d86-c187-a29e-5153-a2e1e5c75e73',
      type: 'class',
      name: 'Team Circles',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4',
      type: 'class',
      name: 'Centered Heading',
      comb: '',
      styleLess: 'margin-bottom: 16px; text-align: center;',
      children: ['d857c47f-13ef-6c7e-7f97-30e5beebeba3'],
      variants: {tiny: {styleLess: 'margin-bottom: 24px;'}},
    },
    {
      _id: 'e8e462ae-eca2-3d8e-55fa-0d15b916d1ba',
      type: 'class',
      name: 'Centered Subheading',
      comb: '',
      styleLess:
        'max-width: 530px; margin-right: auto; margin-left: auto; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'e75db611-ebb8-70fd-6c02-1b92c4dafa11',
      type: 'class',
      name: 'Team Grid',
      comb: '',
      styleLess:
        'display: grid; margin-top: 50px; grid-auto-columns: 1fr; grid-column-gap: 64px; grid-row-gap: 56px; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto auto;',
      children: [],
      variants: {
        medium: {styleLess: 'grid-column-gap: 40px;'},
        small: {styleLess: 'grid-template-columns: 1fr 1fr;'},
        tiny: {styleLess: 'grid-template-columns: 1fr;'},
      },
    },
    {
      _id: '84cd23a0-7acc-6b97-9559-9b46f4b3ea3c',
      type: 'class',
      name: 'Team Card',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; align-items: center; font-size: 14px; line-height: 22px; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'd10cd42c-0487-bbf0-40b1-54a177d72bd9',
      type: 'class',
      name: 'Team Member Image',
      comb: '',
      styleLess:
        'width: 270px; height: 270px; margin-bottom: 24px; border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%; object-fit: cover;',
      children: [],
      variants: {
        medium: {styleLess: 'width: 190px; height: 190px;'},
        xl: {styleLess: 'width: 270px; height: 270px; max-height: none;'},
      },
    },
    {
      _id: '10ea09a1-d6a2-9172-b3a2-cbf78ee99e02',
      type: 'class',
      name: 'Team Member Name',
      comb: '',
      styleLess:
        'margin-bottom: 6px; font-size: 20px; line-height: 32px; font-weight: 500;',
      children: [],
      variants: {},
    },
    {
      _id: 'bff7edfd-b157-9060-4e4f-714ef3b50474',
      type: 'class',
      name: 'Team Member Position',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {},
    },
  ],
} as const;
